(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){

		$('.lightGallery').lightGallery({
			selector: 'a',
			fullScreen: true,
			closable: true,
			hash: false,
			videoMaxWidth: '1920px',
			showThumbByDefault: false,
			thumbnail: false,
			counter: false,
			download: false,
			autoplayControls: false,
			fullScreen: false,
			zoom: false,
			share: false
		});

	});

})(jQuery);
